import React, { useCallback, useMemo, useState } from "react";
import { PluginView } from "../enums";

export const ViewContext = React.createContext({});

const ViewProvider = ({ children }) => {
  const [pluginView, setPluginView] = useState(PluginView.COMPACT);
  const [hasOpenLargeView, setHasOpenLargeView] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  /*
   * Handling plugin view change.
   */

  const onPluginViewChange = useCallback((newPluginView) => {
    setPluginView(newPluginView);
    setIsChatOpen(false);
    if (newPluginView >= PluginView.LARGE) {
      setHasOpenLargeView(true);
    }
  }, []);

  const resetView = useCallback(() => {
    setPluginView(PluginView.COMPACT);
    setHasOpenLargeView(false);
    setIsChatOpen(false);
  }, []);

  const toggleChat = useCallback(() => {
    setIsChatOpen((prev) => !prev);
  }, []);

  const toggleSettings = useCallback(() => {
    setIsSettingsOpen((prev) => !prev);
  }, [])

  const contextValue = useMemo(
    () => ({
      hasOpenLargeView,
      isChatOpen,
      isSettingsOpen,
      onPluginViewChange,
      pluginView,
      resetView,
      toggleChat,
      toggleSettings,
    }),
    [
      hasOpenLargeView,
      isChatOpen,
      isSettingsOpen,
      onPluginViewChange,
      pluginView,
      resetView,
      toggleChat,
      toggleSettings,
    ],
  );

  return (
    <ViewContext.Provider value={contextValue}>{children}</ViewContext.Provider>
  );
};

export default React.memo(ViewProvider);
